import * as Cesium from 'cesium';
import BaseLayer from "./baseLayer";
import CONSTANTS from "../constants";
/**
 * 作业票图层
 */
export default class WorkPermitLayer extends BaseLayer{

    constructor(options={}){
        options.layerName=options.layerName||CONSTANTS.LAYER.WORKPERMIT;//图层名
        super(options);
    }

    addEntities(data){
        let self=this;
        self.clearLayer();
        data.forEach((obj,index) =>{
            let item={...obj};
            item.layerName=self.layerName;
            item.permitTypeName="作业";
            if(item.permitType==0){
                item.permitTypeName="临时用电安全";
            }
            if([1,2,3].indexOf(item.permitType)>-1){
                item.permitTypeName="动火作业安全";
            }
            if(item.permitType==4){
                item.permitTypeName="受限空间安全";
            }
            if(item.permitType==5){
                item.permitTypeName="盲板抽堵安全";
            }
            if(item.permitType==6){
                item.permitTypeName="高处安全作业";
            }
            if(item.permitType==7){
                item.permitTypeName="吊装安全作业";
            }
            if(item.permitType==8){
                item.permitTypeName="断路安全作业";
            }
            if(item.permitType==9){
                item.permitTypeName="动土安全作业";
            }
            if(item.longitude&&item.latitude){
                let entity=new Cesium.Entity({
                    position: Cesium.Cartesian3.fromDegrees(item.longitude,item.latitude, CONSTANTS.ALTITUDE),
                    id:item.id,
                    attributes:item,
                    //立广告牌
                    billboard :{
                        image : "/static/imgs/map/workPermit"+item.permitType+".png",
                        show : true,
                        width : 32,
                        height : 40,
                        pixelOffset:new Cesium.Cartesian2(0, 0)
                    }
                });
                self.dataSource.entities.add(entity);
            }
        });
    }
}
